import { Component } from '@angular/core';

@Component({
    selector: 'app-curious-set-up',
    templateUrl: './curious-set-up.component.html',
    standalone: false
})
export class CuriousSetUpComponent{


}
